<script>
import { contractType } from '@/assets/data/optionData.js';
import AppPopup from '@/components/AppPopup.vue';
import moment from 'moment';
import ElementsModal2Button from '@/components/elements/ElementsModal2Button.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import { ValidateUtil, CommonDataFormatUtil } from '@/plugins/app-util.js';
import { DotsVerticalIcon } from '@heroicons/vue/outline';
import AddIcon from '@/components/design-system/icon/add.vue';


export default {
    components: {
        AppPopup,
        ElementsModal2Button,
        DotsVerticalIcon,
        DesignInput,
        DesignDropdownSelect,
        DesignButton,
        AddIcon,
    },
    props: {
        selectedEmployeeSeq: String,
    },
    data() {
        return {
            // 공통 사용
            userSeq: null,
            nowSave: false,
            employeeSeq: null,
            qualifications: [],
            qualificationSeq: null,
            certificateFile: null,
            popupEditItemsQualification: {
                qualificationSeq: null,
                employeeSeq: null,
                qualificationName: null,
                institution: null,
                qualificationDatetime: null,
                certificateFileName: null,
                certificateFile: null,
            },
            showEditBtn: false,
            // 인풋 값
            filePath: null,
            inputFilePath: null,
            inputFileName: null,
            qualification: {
                status: null,
                file: null,
                qualifications: [],
                request: {
                    employeeSeq: null,
                    qualificationName: null,
                    institution: null,
                    qualificationDatetime: null,
                    certificateFileName: null,
                    certificateFile: null,
                },
            },
            //modal
            showPopupQualification: false,
            showEditPopupQualification: false,
            showCancelCheckModalQualification: false,
            showCancelCheckModalCareer: false,
            showPopupCareer: false,
            showEditPopupCareer: false,
            //career
            careerSeq: null,
            contractTypeOptions: contractType,
            //db data
            careers: [],
            popupEditItemsCareer: {
                employeeSeq: null,
                companyName: null,
                departmentName: null,
                jobTitleName: null,
                workFirstDate: null,
                workLastDate: null,
                contractType: null,
            },
            // add
            career: {
                request: {
                    employeeSeq: null,
                    companyName: null,
                    departmentName: null,
                    jobTitleName: null,
                    workFirstDate: null,
                    workLastDate: null,
                    contractType: null,
                },
            },
        }; // return
    }, // data
    mounted() {
        const self = this;
        self.getListCareer();
        self.getListQualification();
    },
    methods: {
        changeEmployeeType: CommonDataFormatUtil.employmentTypeFormat,
        fileNameConverter(filePath) {
            const params = new URLSearchParams(filePath);
            let fileName = params.get('showName');

            return fileName ? decodeURIComponent(fileName) : '-';
        },
        moment: moment,
        parseInt: parseInt,
        // 공통
        close() {
            const self = this;
            self.showPopupQualification = false;
            self.showEditPopupQualification = false;
            self.showCancelCheckModalQualification = false;
            self.openPhotoView = false;
            self.nowSave = false;

            self.showPopupCareer = false;
            self.showEditPopupCareer = false;
            self.showCancelCheckModalCareer = false;

            self.getListCareer();
            self.getListQualification();
        },
        getListQualification() {
            const self = this;
            const url = self.$api('uri', 'get-employee-qualification').replace('{employeeSeq}', encodeURIComponent(self.selectedEmployeeSeq));
            const json_query = JSON.stringify({
                employeeSeq: self.selectedEmployeeSeq,
            });
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    self.request = res.data.data;
                    const { data } = res;
                    self.qualifications = data.data.list;
                    self.showEditBtn = true;
                })
                .catch((err) => (self.showEditBtn = false));
        },
        //get-info api 사용안함
        getQualificationEdit(arg) {
            const self = this;
            self.showEditPopupQualification = true;
            self.qualification.status = 'edit';

            self.popupEditItemsQualification = { ...arg };
            self.qualificationSeq = self.popupEditItemsQualification.qualificationSeq;
        },
        deleteQualificationModalOpen() {
            const self = this;
            self.close();

            self.showCancelCheckModalQualification = true;
        },
        deleteQualification() {
            const self = this;
            const qualificationSeq = self.popupEditItemsQualification.qualificationSeq;
            const url = self.$api('uri', 'delete-employee-qualification').replace('{qualificationSeq}', encodeURIComponent(qualificationSeq));
            self.$axios
                .delete(url)
                .then((res) => {
                    self.deleteFile(self.popupEditItemsQualification.certificateFile, true);
                    self.close();
                })
                .catch(console.log);
        },
        //add button click
        addQualification() {
            const self = this;
            self.showPopupQualification = true;
            self.nowSave = true;

            //init
            self.qualificationSeq = null;
            self.qualification.request.qualificationName = null;
            self.qualification.request.institution = null;
            self.qualification.request.qualificationDatetime = null;
            self.qualification.request.certificateFileName = null;
            self.qualification.request.certificateFile = null;
        },
        //add save button click
        saveQualification() {
            const self = this;
            if (ValidateUtil.checkIsEmpty(self.qualification.request.qualificationName)) {
                alert('Certificate Name can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(self.qualification.request.institution)) {
                alert('Institution can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(self.qualification.request.qualificationDatetime)) {
                alert('Date can’t be blank');
                return;
            }

            if (self.inputFilePath == null) {
                alert('Certificate File can’t be blank');
                return;
            }
            self.nowSave = false;

            self.submitAfterFileUpload(self.inputFilePath, self.inputFileName);
        },
        //post
        postQualification() {
            const self = this;

            let requestItem = { ...self.qualification.request };
            requestItem['employeeSeq'] = self.selectedEmployeeSeq;

            const url = self.$api('uri', 'post-employee-qualification');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.qualificationSeq = res.data.data.qualificationSeq;

                    //init
                    self.inputFilePath = null;
                    self.inputFileName = null;

                    self.close();
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        //put
        putQualification() {
            const self = this;
            const requestItem = { ...self.popupEditItemsQualification };
            const url = self.$api('uri', 'put-employee-qualification').replace('{qualificationSeq}', encodeURIComponent(self.qualificationSeq));

            self.$axios
                .put(url, requestItem)
                .then((res) => {
                    //init
                    self.inputFilePath = null;
                    self.inputFileName = null;

                    self.close();
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        //edit save button click
        editSaveQualification() {
            const self = this;

            if (ValidateUtil.checkIsEmpty(self.popupEditItemsQualification.qualificationName)) {
                alert('Certificate Name can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(self.popupEditItemsQualification.institution)) {
                alert('Institution can’t be blank');
                return;
            }

            if (ValidateUtil.checkIsEmpty(self.popupEditItemsQualification.qualificationDatetime)) {
                alert('Date can’t be blank');
                return;
            }

            if (self.popupEditItemsQualification.certificateFile == null) {
                alert('Certificate File can’t be blank');
                return;
            }

            if (self.inputFilePath == null) {
                self.putQualification();
                return;
            }

            self.submitAfterFileUpload(self.inputFilePath, self.popupEditItemsQualification.certificateFileName);
        },
        inputFile(file) {
            const self = this;
            //init
            self.inputFilePath = null;
            self.inputFileName = null;

            if (!file) {
                return;
            }

            self.inputFilePath = file;
            self.inputFileName = file.name;
            self.popupEditItemsQualification.certificateFileName = file.name;
            self.qualification.request.certificateFileName = file.name;
        },
        submitAfterFileUpload(filePath, fileName) {
            const self = this;

            const url = self.$api('uri', 'post-file-direct-upload');

            let form = new FormData();
            form.append(`uploadFile1`, filePath);
            form.append(`uploadFileName`, fileName);

            self.$axios
                .post(url, form, { headers: { 'Content-Type': 'multipart/form-data;' } })
                .then((res) => {
                    if (self.qualificationSeq == null) {
                        self.qualification.request.certificateFile = res.data.data.uploadFile1;
                        self.postQualification();
                        return;
                    }
                    self.popupEditItemsQualification.certificateFile = res.data.data.uploadFile1;
                    self.putQualification();
                })
                .catch((err) => {
                    console.error(err);
                    alert(' fail ');
                });
        },
        deleteFile(filePath, isEdit = false) {
            const self = this;
            self.inputFileName = null;
            self.inputFilePath = null;
            if (isEdit) {
                self.popupEditItemsQualification.certificateFile = null;
                self.popupEditItemsQualification.certificateFileName = null;
            }

            if (!filePath) {
                return;
            }
            self.$axios
                .delete(filePath)
                .then((res) => {})
                .catch((err) => {
                    console.error(err);
                });
        },
        //career
        deleteCareer() {
            const self = this;
            const params = new URLSearchParams(document.location.search);
            params.append('careerSeq', self.careerSeq);
            const careerSeq = params.get('careerSeq');
            const url = self.$api('uri', 'delete-employee-career');
            self.$axios
                .delete(`${url}/${careerSeq}`)
                .then((res) => {
                    self.close();
                })
                .catch(console.log);
        },
        deleteCareerModalOpen() {
            const self = this;
            self.modelValue = false;
            self.showEditModal = false;
            //== 해당 변수 없음
            // self.modelValueQualification = false;
            // self.showEditModalQualification = false;
            self.showCancelCheckModalCareer = true;
        },
        saveCareerInfo() {
            const self = this;
            const requestItem = { ...self.career.request };
            requestItem['employeeSeq'] = self.selectedEmployeeSeq;

            if (ValidateUtil.checkIsEmpty(requestItem.companyName)) {
                alert('Company Name can’t be blank');
                return;
            }

            if (parseInt(requestItem.workLastDate) < parseInt(requestItem.workFirstDate)) {
                alert('Please enter the correct date');
                return;
            }

            const url = self.$api('uri', 'post-employee-career');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.nowSave = false;
                    self.showPopupCareer = false;
                    self.getListCareer();
                    self.showEditBtn = true;
                })
                .catch((err) => {
                    console.log(err.response);
                    self.showEditBtn = false;
                });
        },
        editSaveButtonClick() {
            const self = this;
            const requestItem = { ...self.popupEditItemsCareer };

            if (ValidateUtil.checkIsEmpty(requestItem.companyName)) {
                alert('Company Name can’t be blank');
                return;
            }

            if (parseInt(requestItem.workLastDate) < parseInt(requestItem.workFirstDate)) {
                alert('Please enter the correct date');
                return;
            }

            const url = self.$api('uri', 'put-employee-career');
            self.$axios
                .put(`${url}/${encodeURIComponent(self.careerSeq)}`, requestItem)
                .then((res) => {
                    self.showEditPopupCareer = false;
                    self.getListCareer();
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        editButtonClick(arg) {
            const self = this;
            self.showEditPopupCareer = true;

            //init
            self.popupEditItemsCareer.companyName = '';
            self.popupEditItemsCareer.departmentName = '';
            self.popupEditItemsCareer.jobTitleName = '';
            self.popupEditItemsCareer.workFirstDate = '';
            self.popupEditItemsCareer.workLastDate = '';
            self.popupEditItemsCareer.contractType = null;

            self.beforeEditData = { ...arg };
            self.popupEditItemsCareer = self.beforeEditData;
            self.careerSeq = arg.careerSeq;
        },
        cancelCareerButtonClick() {
            const self = this;
            self.showPopupCareer = false;
            self.nowSave = false;
        },
        addCareerButtonClick() {
            const self = this;
            self.showPopupCareer = true;
            self.nowSave = true;

            //init
            self.career.request.companyName = '';
            self.career.request.departmentName = '';
            self.career.request.jobTitleName = '';
            self.career.request.workFirstDate = '';
            self.career.request.workLastDate = '';
            self.career.request.contractType = null;
        },
        getListCareer() {
            const self = this;
            const url = self.$api('uri', 'get-employee-career').replace('{employeeSeq}', encodeURIComponent(self.selectedEmployeeSeq));
            const json_query = JSON.stringify({
                employeeSeq: self.selectedEmployeeSeq,
            });
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                self.request = res.data.data;
                const { data } = res;
                self.careers = data.data.list;
            });
        },
    },
}; // return
</script>
<template>
    <div>
        <!-- Work Experience list START-->
        <div class="flex justify-between items-center my-4">
            <h4 class="font-heading-sm-semibold">Work Experience({{ careers.length }})</h4>
            <DesignButton
                    v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn"
                    btnText="Add"
                    btnSize="SM"
                    btnType="PRIMARY"
                    btnVariant="BORDER"
                    :btnDisabled="false"
                    @click="addCareerButtonClick()"
            >
                <template #front-icon>
                    <AddIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                </template>
            </DesignButton>
        </div>
        <div class="flex flex-col gap-2">
            <div v-for="(career, index) in careers" v-bind:key="index">
                <div class="w-full h-auto border-1 p-4 border-border-basic-2 rounded-3 flex flex-col gap-1">
                    <div class="flex justify-between gap-2">
                        <h5 class="font-body-md-semibold w-full">{{ career.companyName }}</h5>
                        <DotsVerticalIcon class="h-5 w-5 text-content-basic-3 cursor-pointer flex-shrink-0" aria-hidden="true" @click="editButtonClick(career)" v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn" />
                    </div>
                    <div class="flex gap-1">
                        <div class="font-body-sm-medium text-content-basic-2">
                            <p v-if="!career.workFirstDate">-</p>
                            <p v-else>
                                {{ moment(career.workFirstDate, 'YYYYMMDD').format('MM/DD/YYYY') }}
                            </p>
                        </div>
                        <p class="font-body-sm-medium text-content-basic-3">~</p>
                        <div class="font-body-sm-medium text-content-basic-2">
                            <p v-if="!career.workLastDate">-</p>
                            <p v-else>
                                {{ moment(career.workLastDate, 'YYYYMMDD').format('MM/DD/YYYY') }}
                            </p>
                        </div>
                        <div class="font-body-sm-medium text-content-basic-2 flex ml-1">
                            (
                                <p v-if="!career.contractType">-</p>
                                <p v-else>
                                    {{ changeEmployeeType(career.contractType) }}
                                </p>
                            )
                        </div>
                    </div>
                    <div class="font-body-sm-regular text-content-basic-3 flex gap-1">
                        <p>Department</p>
                        <p>:</p>
                        <p v-if="!career.departmentName">-</p>
                        <p v-else>
                            {{ career.departmentName }}
                        </p>
                    </div>
                    <div class="font-body-sm-regular text-content-basic-3 flex gap-1">
                        <p>Tier</p>
                        <p>:</p>
                        <p v-if="!career.jobTitleName">-</p>
                        <p v-else>
                            {{ career.jobTitleName }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Work Experience list END-->

        <!-- Certificate list START-->
         <div class="flex justify-between items-center my-4 mt-8">
            <h4 class="font-heading-sm-semibold">Certificate({{ qualifications.length }})</h4>
            <DesignButton
                    v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn"
                    btnText="Add"
                    btnSize="SM"
                    btnType="PRIMARY"
                    btnVariant="BORDER"
                    :btnDisabled="false"
                    @click="addQualification()"
            >
                <template #front-icon>
                    <AddIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                </template>
            </DesignButton>
        </div>
        <div class="flex flex-col gap-2">
            <div v-for="(qualification, index) in qualifications" v-bind:key="index">
                <div class="w-full h-auto border-1 p-4 border-border-basic-2 rounded-3 flex flex-col gap-1">
                    <div class="flex justify-between gap-2">
                        <h5 class="font-body-md-semibold w-full break-all">{{ qualification.qualificationName }}</h5>
                        <DotsVerticalIcon class="h-5 w-5 text-content-basic-3 cursor-pointer flex-shrink-0" aria-hidden="true" @click="getQualificationEdit(qualification)" v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn" />
                    </div>
                    <div class="font-body-sm-medium text-content-basic-2">
                        <p v-if="!qualification.qualificationDatetime">-</p>
                        <p v-else>
                            {{ moment(qualification.qualificationDatetime).format('MM/DD/YYYY') }}
                        </p>
                    </div>
                    <div class="font-body-sm-regular text-content-basic-3 flex gap-1">
                        <p>Institution</p>
                        <p>:</p>
                        <p v-if="!qualification.institution">-</p>
                            <p v-else class="break-all">
                                {{ qualification.institution }}
                            </p>
                    </div>
                    <div class="flex items-center gap-1">
                        <!--file icon 추가 필요-->
                        <template v-if="!qualification.certificateFileName">
                            <p class="font-body-sm-regular text-primary-3">-</p>
                        </template>
                        <template v-else>
                            <a :href="qualification.certificateFile">
                                <p style="white-space: pre-line" class="font-body-sm-medium text-primary-3">
                                    {{ qualification.certificateFileName }}
                                </p>
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!-- Certificate list END-->

        <!-- Modal add career START-->
        <Teleport to="body">
            <AppPopup v-model="showPopupCareer" name="Add Work Experience" @afterClose="getListCareer()" max-width='640px'>
                <div class="p-6 pt-1">
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Company Name</div>
                        <DesignInput 
                            v-model="career.request.companyName" 
                            placeholder="Enter Company Name" 
                            class="flex-1" 
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Department</div>
                        <DesignInput 
                            v-model="career.request['departmentName']" 
                            placeholder="Enter Department" 
                            class="flex-1"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Tier</div>
                        <DesignInput 
                            v-model="career.request['jobTitleName']" 
                            placeholder="Enter Tier" 
                            class="flex-1"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">First day of work</div>
                        <ElementsDatePicker v-model="career.request.workFirstDate" placeholder="Select Date" class="flex-1" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Last day of work</div>
                        <ElementsDatePicker v-model="career.request.workLastDate" placeholder="Select Date" class="flex-1" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Contract Type</div>
                        <DesignDropdownSelect
                            v-model="career.request.contractType"
                            placeholder="Select Contract Type"
                            class="flex-1"
                            width="w-full"
                            :options="contractTypeOptions"
                        />
                    </div>
                </div>
                <!-- add button -->
                 <div class="flex w-full bg-white">
                    <div class="w-full p-4 border-t-1 border-border-basic-2 justify-end flex gap-2">
                        <DesignButton v-show="nowSave" btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" class="w-[6rem]" @click="close()"/>
                        <DesignButton v-show="nowSave" btnType="PRIMARY" btnVariant="FILL" btnText="Save" class="w-[6rem]" @click="saveCareerInfo()"/>
                    </div>
                </div>
            </AppPopup>
        </Teleport>
        <!-- Modal add career END-->

        <!-- Modal edit career START -->
        <Teleport to="body">
            <AppPopup v-model="showEditPopupCareer" name="Edit Work Experience" @afterClose="getListCareer()" max-width='640px'>
                <div class="p-6 pt-1">
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Company Name</div>
                        <DesignInput v-model="popupEditItemsCareer.companyName" placeholder="Enter Company name" class="flex-1"/>
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-6">
                        <div class="c_label w-[10rem]">Department</div>
                        <DesignInput v-model="popupEditItemsCareer.departmentName" placeholder="Enter Department" class="flex-1"/>
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-6">
                        <div class="c_label w-[10rem]">Tier</div>
                        <DesignInput v-model="popupEditItemsCareer.jobTitleName" placeholder="Enter Tier" class="flex-1"/>
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-6">
                        <div class="c_label w-[10rem]">First Day Of Work</div>
                        <ElementsDatePicker v-model="popupEditItemsCareer.workFirstDate" placeholder="Select Date" class="flex-1" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-6">
                        <div class="c_label w-[10rem]">Last Day Of Work</div>
                        <ElementsDatePicker v-model="popupEditItemsCareer.workLastDate" placeholder="Select Date" class="flex-1" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-6">
                        <div class="c_label w-[10rem]">Contract Type</div>
                        <DesignDropdownSelect
                            v-model="popupEditItemsCareer.contractType"
                            placeholder="Select Contract Type"
                            class="flex-1"
                            width="w-full"
                            :options="contractTypeOptions"
                            :useDefaultMsg="true" />
                    </div>
                </div>
                <div class="flex w-full bg-white">
                    <div class="w-full p-4 border-t-1 border-border-basic-2 flex justify-between">
                        <DesignButton btnType="RED" btnVariant="FILL" btnText="Delete" class="w-[6rem]" @click="deleteCareerModalOpen()"/>
                        <div class="justify-end flex gap-2">
                            <DesignButton btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" class="w-[6rem]" @click="close()"/>
                            <DesignButton btnType="PRIMARY" btnVariant="FILL" btnText="Save" class="w-[6rem]" @click="editSaveButtonClick()"/>
                        </div>
                    </div>
                </div>
            </AppPopup>
            <!-- edit delete check modal -->
            <ElementsModal2Button v-model="showCancelCheckModalCareer" hasAlertIcon="true" modalTitle="Are you sure you want to delete?" buttonText="Delete" buttonColor="RED" modalContent="" @afterClick="deleteCareer" />
        </Teleport>
        <!-- Modal edit career END -->
        
        <!-- Modal add Qualification START -->
        <Teleport to="body">
            <div id="showPopupQualification">
                <AppPopup v-model="showPopupQualification" name="Add Certificate" @afterClose="close()" max-width='640px'>
                    <div class="p-6 pt-1">
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem]">Certificate Name</div>
                            <DesignInput v-model="qualification.request['qualificationName']" placeholder="Enter Certificate Name" class="flex-1" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem]">Institution</div>
                            <DesignInput v-model="qualification.request['institution']" placeholder="Enter Institution" class="flex-1" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem]">Date</div>
                            <ElementsDatePicker v-model="qualification.request.qualificationDatetime" placeholder="Select Date" class="flex-1" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem] flex-shrink-0">Certificate File</div>
                            <div class="w-full flex justify-between gap-2">
                                <ElementsInput v-model="qualification.request['certificateFileName']" placeholder="Choose File" :readonly="true" :full="true" class="flex-1" />

                                <div class="flex justify-center items-center">
                                    <img src="@/assets/img/delete.svg" width="14" height="14" class="ml-2 cursor-pointer" v-show="inputFileName" @click="deleteFile()" />
                                </div>

                                <a v-show="!inputFileName" href="javascript:void(0)" class="flex items-center" @click="$refs.file.click">
                                    <img src="@/assets/img/browse.svg" />
                                    <span class="ml-0.5 text-sm font-normal text-blue-500">Browse</span>
                                    <input type="file" class="hidden" ref="file" @input="inputFile($event.target.files[0])" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full bg-white">
                        <div class="w-full p-4 border-t-1 border-border-basic-2 justify-end flex gap-2">
                            <DesignButton v-show="nowSave" btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" class="w-[6rem]" @click="close()"/>
                            <DesignButton v-show="nowSave" btnType="PRIMARY" btnVariant="FILL" btnText="Save" class="w-[6rem]" @click="saveQualification()"/>
                        </div>
                    </div>
                </AppPopup>
            </div>
        </Teleport>
        <!-- Modal add Qualification END -->

        <!-- Modal edit Qualification START -->
        <Teleport to="body">
            <div id="showEditPopupQualification">
                <AppPopup v-model="showEditPopupQualification" name="Edit Certificate" @afterClose="close()" max-width='640px'>
                    <div class="p-6 pt-1">
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem]">Certificate Name</div>
                            <DesignInput v-model="popupEditItemsQualification['qualificationName']" placeholder="Enter Certificate Name" class="flex-1" :full="true" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-6">
                            <div class="c_label w-[10rem]">Institution</div>
                            <DesignInput v-model="popupEditItemsQualification['institution']" placeholder="Enter Institution" class="flex-1" :full="true" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem]">Date</div>
                            <ElementsDatePicker v-model="popupEditItemsQualification.qualificationDatetime" placeholder="Select Date" class="flex-1" />
                        </div>
                        <div class="flex justify-between items-center gap-2 mt-4">
                            <div class="c_label w-[10rem] flex-shrink-0">Certificate File</div>
                            <div class="w-full flex justify-between gap-2">
                                <DesignInput v-model="popupEditItemsQualification['certificateFileName']" placeholder="Choose File" :readonly="true" :full="true" class="flex-1" />
                                <img
                                    src="@/assets/img/delete.svg"
                                    width="14"
                                    height="14"
                                    class="ml-2 cursor-pointer"
                                    v-show="popupEditItemsQualification.certificateFileName"
                                    @click="deleteFile(popupEditItemsQualification.certificateFile, true)" />
    
                                <a v-show="!popupEditItemsQualification.certificateFileName" href="javascript:void(0)" class="flex items-center" @click="$refs.file.click">
                                    <img src="@/assets/img/browse.svg" />
                                    <span class="ml-0.5 text-sm font-normal text-blue-500">Browse</span>
                                    <input type="file" class="hidden" ref="file" @input="inputFile($event.target.files[0])" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="p-4 flex justify-end items-felx-end w-full bg-white border-t bg-white-200">
                        <ElementsButton text="Delete" :width28="true" :height12="true" :background-red="true" @click="deleteQualificationModalOpen()" />
                        <ElementsButton class="ml-2" text="Save" :width28="true" :height12="true" @click="editSaveQualification()" />
                    </div>
                </AppPopup>
            </div>
            <ElementsModal2Button v-model="showCancelCheckModalQualification" modalTitle="" buttonText="Confirm" modalContent="Are you sure you want to delete?" @afterClick="deleteQualification" />
        </Teleport>
        <!-- Modal edit Qualification END -->
    </div>
</template>
